/* Cart-page acknowledgment before the normal Shopify checkout button. */
(() => {
  'use strict';
  function init() {
    document.querySelectorAll('[data-dm-cart-form]').forEach(form => {
      if (form.dataset.dmConsentReady) return;
      form.dataset.dmConsentReady = 'true';
      const checkbox = form.querySelector('[data-dm-road-consent]');
      const error = form.querySelector('[data-dm-consent-error]');
      const checkout = form.querySelector('[data-dm-checkout]');
      if (!checkbox || !checkout || !error) return;
      const showError = () => { error.hidden = false; checkbox.setAttribute('aria-invalid', 'true'); };
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) { error.hidden = true; checkbox.removeAttribute('aria-invalid'); }
      });
      checkout.addEventListener('click', event => {
        if (!checkbox.checked) {
          event.preventDefault();
          showError();
          checkbox.focus();
        }
      });
      form.addEventListener('submit', event => {
        if (event.submitter?.name !== 'checkout') return; // Updating quantities must remain possible.
        if (!checkbox.checked) {
          event.preventDefault();
          showError();
          checkbox.focus();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
